module.exports = __webpack_public_path__ + "img/catheter.0a809d47.png";